export const STORAGE_CONSTANTS = {
  tokenName: '_ut'
}
